import {
  DateFormatted,
  DownloadableThumbnail,
  EmployeeThumb,
  LoadingSpinner,
  Typography,
} from '@components';
import { useCompany } from '@hooks';
import { DefaultEmployeeInterface } from '@interfaces';
import { AttachmentService } from '@services';
import { ListComponent } from '@utils';
import React, { useState } from 'react';
import { Paperclip } from 'react-feather';

interface CommentItemProps {
  name: string;
  date: string;
  comment: string;
  user?: DefaultEmployeeInterface;
  attachments: string[];
}

const SIZE = 12;

export const CommentItem = ({
  name,
  date,
  comment,
  user,
  attachments,
}: CommentItemProps) => {
  const cleanAttachments = (attachments || []).filter(Boolean);
  const attachmentService = new AttachmentService();
  const [urls, setUrls] = useState();
  const [loading, setLoading] = useState<boolean>(false);
  const { companyId, companyName } = useCompany();

  const downloadAttachment = async () => {
    setLoading(true);
    try {
      const signedUrls = await Promise.all(
        cleanAttachments.map(async (fileName: string) => {
          const response = await attachmentService.getSignedUrl(
            companyId,
            fileName
          );
          return {
            fileName,
            url: response,
          };
        })
      );

      setUrls(signedUrls);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error('Error getting signed URLs:', error);
    }
  };

  return (
    <div className="flex items-start gap-3 mb-4">
      {/* Avatar */}
      <div className={`flex-shrink-0 w-${SIZE} h-${SIZE} mr-5`}>
        {user && user.med_foto ? (
          <EmployeeThumb
            name={user.med_naam}
            image={user.med_foto}
            size={SIZE}
          />
        ) : (
          <div
            className={`w-${SIZE} h-${SIZE} rounded-full ring-2 outline outline-2 outline-offset-2 outline-violet-400 ring-gray-100 bg-gray-200 flex items-center justify-center`}
          >
            <span className="text-gray-500 text-xs font-bold ">{name}</span>
          </div>
        )}
      </div>

      <div className="flex-1">
        <div className="flex items-center flex-wrap">
          <Typography tag="span" type="label">
            {name ? name : user?.med_naam && user.med_naam}
          </Typography>

          <Typography tag="span" type="label" addClass="ml-2">
            <DateFormatted date={date} icon time />
          </Typography>

          {cleanAttachments?.length > 0 && (
            <>
              {loading ? (
                <LoadingSpinner />
              ) : (
                <Paperclip size={14} onClick={() => downloadAttachment()} />
              )}
              <Typography tag="span" type="label" addClass="">
                {cleanAttachments.length}
              </Typography>
            </>
          )}
        </div>

        <Typography tag="p" type="default" addClass="mt-2">
          {comment}
        </Typography>
        {urls && (
          <div className="grid grid-cols-4 gap-4">
            <ListComponent
              data={urls}
              renderItem={(url) => <DownloadableThumbnail url={url.url} />}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default CommentItem;
